module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": (this.projeto.situacao.item === 18 || this.projeto.situacao.item === 3) ? 'Suspender Ação de Extensão' : 'Prorrogar suspensão da ação de extensão'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-dialog', {
    attrs: {
      "width": "550"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n                    " + _vm._s((this.projeto.situacao.item === 18 || this.projeto.situacao.item === 3) ? 'Confirma a suspensão da ação de extensão?' : 'Confirma a prorrogação da suspensão da ação de extensão?') + "\n                  ")]), _vm._v(" "), _c('v-card-text'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Não")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.suspenderProrrogarAcaoExtensao()
      }
    }
  }, [_vm._v("Sim")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Título",
      "value": this.projeto.titulo
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Número",
      "value": this.projeto.idProjeto
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Situação",
      "value": this.projeto.situacao.descricao
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Data de início da ação de extensão",
      "value": _vm.dates.format(this.projeto.dataInicio)
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Data de conclusão da ação de extensão",
      "value": _vm.dates.format(this.projeto.dataConclusao)
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Coordenador",
      "value": this.projeto.nomeCoordenador
    }
  })], 1)], 1), _vm._v(" "), (this.projeto.situacao.item === 4) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "labelSuspensoes"
  }, [_vm._v("Suspensões")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.listaSuspensoes.length !== 0) ? _c('v-data-table', {
    staticClass: "elevation-1 suspensoes",
    attrs: {
      "headers": _vm.headersSuspensoes,
      "header-props": {
        sortIcon: null
      },
      "items": _vm.listaSuspensoes,
      "items-per-page": -1,
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "item.dtInicioSuspensao",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dtInicioSuspensao)))]
      }
    }, {
      key: "item.dtFimSuspensao",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dtFimSuspensao)))]
      }
    }], null, false, 4036453385)
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Processo*",
      "rules": _vm.obrigatorio,
      "prepend-icon": "feed"
    },
    model: {
      value: (_vm.suspensao.processo),
      callback: function($$v) {
        _vm.$set(_vm.suspensao, "processo", $$v)
      },
      expression: "suspensao.processo"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('c-date-dialog', {
    attrs: {
      "label": (this.projeto.situacao.item === 18 || this.projeto.situacao.item === 3) ? 'Data de início da suspensão*' : 'Data de início da nova suspensão*',
      "rules": _vm.obrigatorio
    },
    model: {
      value: (_vm.suspensao.dtInicioSuspensao),
      callback: function($$v) {
        _vm.$set(_vm.suspensao, "dtInicioSuspensao", $$v)
      },
      expression: "suspensao.dtInicioSuspensao"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('c-date-dialog', {
    attrs: {
      "label": (this.projeto.situacao.item === 18 || this.projeto.situacao.item === 3) ? 'Data de fim da suspensão*' : 'Data de fim da nova suspensão*',
      "rules": _vm.obrigatorio
    },
    model: {
      value: (_vm.suspensao.dtFimSuspensao),
      callback: function($$v) {
        _vm.$set(_vm.suspensao, "dtFimSuspensao", $$v)
      },
      expression: "suspensao.dtFimSuspensao"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-textarea', {
    attrs: {
      "label": "Justificativa/Observação",
      "rules": _vm.tamanho2000caracteres,
      "rows": 3,
      "auto-grow": true,
      "multi-line": "",
      "counter": "2000",
      "required": ""
    },
    model: {
      value: (_vm.suspensao.justificativaObservacao),
      callback: function($$v) {
        _vm.$set(_vm.suspensao, "justificativaObservacao", $$v)
      },
      expression: "suspensao.justificativaObservacao"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.cancelar
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        _vm.dialog = true
      }
    }
  }, [_vm._v("\n              " + _vm._s((this.projeto.situacao.item === 18 || this.projeto.situacao.item === 3) ? 'Suspender' : 'Prorrogar') + "\n            ")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45a00cc2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/administracao/suspender-acao-extensao.vue
// module id = 684
// module chunks = 0